export enum AdyenDeviceModel {
  Saturn1000F2 = 'Saturn1000F2',
  AMS1 = 'AMS1',
  S1F2 = 'S1F2',
}
